var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w3-content w3-center"},[_vm._m(0),_c('h1',[_vm._v(_vm._s(_vm.$t('applicationTitle1')))]),_c('h2',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.$t('applicationTitle2')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"id":"bfrlogo","src":require("../assets/img/bfrlogo.svg"),"alt":"BfR Logo"}})])
}]

export { render, staticRenderFns }